import React, { Component, useRef, forwardRef, useEffect } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import '../../../../styles/invoicesPrint.css';
import fmplogo from '../../../../assets/FMP-Icon.png';
import SopRotatesPrintPage from './SopRotatesPrintPage';
import RotatesTable from '../../../shared/RotatesTable';
// import { fetchRotatesInvno } from '../../../../redux/actions/PostActions';

const InvoicesPrintPage = forwardRef(function PrintPage(props, ref) {
    const { invoicesPrintState, invoicesState, fetch_InvoicesPrintDetail} = props;
    
    console.log('InvoicesPrintPage invoicesPrintState: ', invoicesPrintState);
    console.log('InvoicesPrintPage invoicesState: ', invoicesState);

    
    // if(invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['ROTATE_REQUEST'] === -1){
    //     fetch_rotatesInvno(invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['INVNO'])  
    //     console.log('InvoicesPrintPage test') 
    // }
                     


    // console.log('InvoicesPrintPage ref: ' + JSON.stringify(ref));
    // console.log('InvoicesPrintPage props: ' + JSON.stringify(props));
    
    let maxRowsPerPage = 9;
    let rowCountPerPage = 0;    
    let listTotal = 1 
    let pageNumber = 0;
    let pageTotal = Math.floor(listTotal/maxRowsPerPage)+1;
    let reminingLinesToFill = (rowCountPerPage % maxRowsPerPage === 0) ? 0 : maxRowsPerPage - (rowCountPerPage % maxRowsPerPage);

    let colTotal = 10;

    let HeaderTable = (invno, invnoData) => {

        // console.log('InvoicesPrintPage  HeaderTable: ', invnoData, invno)
        
        listTotal =  Object.values(invnoData).length

        pageTotal = Math.floor(listTotal/maxRowsPerPage)+1;
        pageNumber = pageNumber + 1 

        // console.log('InvoicesPrintPage HeaderTable invno', invno, 'listTotal: ', listTotal, ' pageTotal:', pageTotal, 'pageNumber', pageNumber, 'rowCountPerPage', rowCountPerPage, 'maxRowsPerPage', maxRowsPerPage)

        var invnoHeadingInfo = invnoData[0]
        
        return(
            <thead key={pageNumber + '_' + invno + '_headerTable'} >
                <tr style={{width:'100%'}} >
                    <td colSpan={colTotal} style={{width:'100%'}} >                            
                        <table className='printMarginHeaderCN'>
                            <thead></thead>
                            <tbody key={pageNumber + '_headerTable_bodyMain'}>
                                <tr>
                                    <td className={'logo'}>
                                        <img src={fmplogo} alt='FMP Logo' width={142}/>                                        
                                        <br/>
                                        <span className={'fmpCorpAddress'}>                                        
                                            2782 EAGANDALE BOULEVARD<br/>
                                            EAGAN, MN 55121-1202<br/>
                                            Phone: 651-405-3610 --- Questions/Concerns: 920-224-2445 
                                        </span>
                                    </td>
                                    <td className={'barcode'}></td>
                                    {/* <td className={'remitTo'}>
                                        Remit to:<br/>
                                        Factory Motor Parts<br/>
                                        Bin 139107<br/>
                                        PO Box 9107<br/>
                                        Minneapolis, MN 55480-9107
                                    </td> */}
                                    <td className={'invoiceInfoTbl1'}>
                                        <table>
                                            <thead></thead>
                                            <tbody key={pageNumber + '_headerTable_bodyInvoiceInfo'}>
                                                <tr>
                                                    <td colSpan={2}>INVOICE</td>
                                                </tr>
                                                <tr>
                                                    <td>DATE</td>
                                                    <td>INVOICE NO.</td>
                                                </tr>
                                                <tr>                                          
                                                    <td>{invnoHeadingInfo['INVOICE_DATE']}</td>
                                                    <td>{invnoHeadingInfo['INVNO']}</td>
                                                </tr>
                                                <tr>
                                                    <td>CUST. PO#</td>
                                                    <td>ACCOUNT #</td>
                                                </tr>
                                                <tr>                                           
                                                    <td>{invnoHeadingInfo['CUST_PO']}</td>
                                                    <td>{invnoHeadingInfo['CUSTNO']}</td>
                                                </tr>  
                                            </tbody>                                                                              
                                        </table>
                                    </td>                                                                 
                                </tr>
                            </tbody>
                        </table>

                    </td>
                </tr>
                <tr>
                    <td colSpan={colTotal} className={'invoiceInfoTbl2'}>
                        <table>
                            <thead></thead>
                            <tbody key={pageNumber + '_headerTable_bodyInvoiceInfo2'}>
                                <tr>
                                    <td>PICK TICKET #</td>
                                    <td>SHIP VIA</td>
                                    <td>DELIVERY DATE</td>
                                    <td>TERMS</td>
                                    <td>SLS REP</td>
                                    <td>KEYED</td>
                                    <td>PAGE</td>
                                </tr>
                                <tr>
                                    <td>{invnoHeadingInfo['PICKTICKET']}</td>
                                    <td>{invnoHeadingInfo['SHIPVIA_DESC']}</td>
                                    <td></td>
                                    <td>{invnoHeadingInfo['TERMS_DESC']}</td>
                                    <td>{invnoHeadingInfo['SLSMNO']}</td>
                                    <td>{invnoHeadingInfo['WRITER']}</td>
                                    <td>{pageNumber} OF {pageTotal}</td>
                                </tr>                            
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td colSpan={colTotal} className={'invoiceInfoTbl3_addresses'}>
                        <table>
                            <thead></thead>
                            <tbody key={pageNumber + '_headerTable_bodyInvoiceInfo3'}>
                                <tr>
                                    <td>
                                        <table className={'addressTblCN'}>
                                            <thead></thead>
                                            <tbody key={pageNumber + '_headerTable_bodyAddressBill'}>
                                                <tr>
                                                    <td>SOLD TO</td>
                                                    <td className={'addressCol1'} style={{borderRight:'none'}}>
                                                        {invnoHeadingInfo['BILL_TO_CUSTNO']}<br/>
                                                        {invnoHeadingInfo['BILL_TO_CUSTNAME']}<br/>
                                                        {invnoHeadingInfo['BILL_TO_ADDR1']}<br/>
                                                        {invnoHeadingInfo['BILL_TO_ADDR2']} {invnoHeadingInfo['BILL_TO_ADDR2'] !== '' ? <br/> : ''}
                                                        {invnoHeadingInfo['BILL_TO_ADDR3']} {invnoHeadingInfo['BILL_TO_ADDR3'] !== '' ? <br/> : ''}
                                                        {invnoHeadingInfo['BILL_TO_CITY']}, {invnoHeadingInfo['BILL_TO_STATE']} {invnoHeadingInfo['BILL_TO_ZIP']}<br/>
                                                        <br/>
                                                    
                                                        {invnoHeadingInfo['BILL_TO_CUST_PHONE']}<br/>
                                                    </td>
                                                    <td className={'addressColPrintDate'} style={{borderLeft:'none'}}>
                                                        PD: <br/>
                                                        PT: 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td>
                                        <table className={'addressTblCN'}>
                                            <thead></thead>
                                            <tbody key={pageNumber + '_headerTable_bodyAddressShip'}>
                                                <tr>
                                                    <td>SHIP TO</td>
                                                    <td>
                                                        {invnoHeadingInfo['CUSTNO']}<br/>
                                                        {invnoHeadingInfo['SHIP_TO_NAME']}<br/>
                                                        {invnoHeadingInfo['SHIP_TO_ADDR1']}<br/>
                                                        {invnoHeadingInfo['SHIP_TO_ADDR2']} {invnoHeadingInfo['SHIP_TO_ADDR2'] !== '' ? <br/> : ''}
                                                        {invnoHeadingInfo['SHIP_TO_ADDR3']} {invnoHeadingInfo['SHIP_TO_ADDR3'] !== '' ? <br/> : ''}
                                                        {invnoHeadingInfo['SHIP_TO_CITY']}, {invnoHeadingInfo['SHIP_TO_STATE']} {invnoHeadingInfo['SHIP_TO_ZIP']}<br/>
                                                        <br/>
                                                    
                                                        {invnoHeadingInfo['SHIP_TO_CUST_PHONE']}<br/>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>                
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr key='customerMessage'>
                    <td colSpan={colTotal} style={{textAlign:"left"}} >{invnoHeadingInfo['MESSAGE_TEXT'] !== '' ? invnoHeadingInfo['MESSAGE_TEXT'] : ''}</td>
                </tr>
                <tr key='header' className={'colheader'}>
                    <th>ORDER QTY</th>
                    <th>SHIP QTY</th>
                    <th>UNIT</th>
                    <th>PART #</th>
                    <th>DESCRIPTION</th>
                    <th>OEM</th>
                    <th>PRICE EA.</th>
                    <th></th>
                    <th>NET PRICE</th>
                    <th>NET EXT.</th>                    
                </tr>                
            </thead>
        )
    }

    let FooterTable = (invno, endOfTblFlag) => {         
        // console.log('InvoicesPrintPage FooterTable invno', invno , 'pageNumber was', pageNumber, 'rowCountPerPage', rowCountPerPage, 'endOfTblFlag', endOfTblFlag)

        if(endOfTblFlag === true){
            rowCountPerPage = 0
            pageNumber = 0
            // console.log('InvoicesPrintPage FooterTable invno', invno , 'pageNumber now', pageNumber, 'rowCountPerPage',rowCountPerPage)
        }
        return (            
            <tbody className='printMarginFooterCN printpage_footer' key={invno + '_' + pageNumber + '_footerTable'}>                
                <tr>   
                    <td colSpan={10}>
                        <table>
                            <thead></thead>
                            <tbody>
                                <tr>                                
                                    <td className='footerSignatureBoxColCN'>
                                        <table>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table>
                                                            <thead></thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Customer's Signature</td>
                                                                    <td>___________________</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Print Name</td>
                                                                    <td>___________________</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Date</td>
                                                                    <td>___________________</td>
                                                                </tr>    
                                                            </tbody>                                            
                                                        </table>
                                                    </td>
                                                    <td>
                                                        <table>
                                                            <thead></thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Driver's Signature</td>
                                                                    <td>___________________</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Print Name</td>
                                                                    <td>___________________</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='footerSignatureBoxCN'>Date</td>
                                                                    <td>___________________</td>
                                                                </tr>
                                                            </tbody>                                         
                                                        </table>
                                                    </td>                                
                                                </tr> 
                                            </tbody>
                                                        
                                        </table>
                                    </td>

                                    <td className='footerSecondBoxCN'  style={{paddingLeft:'3px'}}>* THIS IS NOT A BILL *</td>  
                                </tr>
                            </tbody>

                        </table>
                    </td>                    
                </tr>                
                <tr>   
                    <td className='footerNoteCN' colSpan={10}>Note: Returns are subject to a restocking charge. Any claim or return must have prior written authorization. Fiance charges will be 1.5% per month applied to all past due invoices.</td>
                </tr>
            </tbody> 
        )
    }

    let PageBreak = (invno, index, fromName) => {
        let componentKey = invno + '_' + index + '_' + rowCountPerPage + fromName
        return (
            <tbody key={componentKey} style={{border:'none', visibility: 'hidden'}}>
                <tr><td className='pageBreakCL' colSpan={10} style={{border:'none', visibility: 'hidden'}}></td></tr>
            </tbody>
        )
    }

    let itemList = (invno, invnoData) => invnoData.map((item,index)=>{
        rowCountPerPage += 1
        // console.log('InvoicesPrintPage itemList called invnoData: ', invnoData)
        // console.log('InvoicesPrintPage itemList called invnoData item: ', item)
        reminingLinesToFill = (rowCountPerPage % maxRowsPerPage === 0) ? 0 : maxRowsPerPage - (rowCountPerPage % maxRowsPerPage);
        listTotal =  Object.values(invnoData).length

        var rowKey = item.INVNO + '_' + index;
        // console.log('InvoicesPrintPage itemList called invno', item.INVNO + ' index: ' + index + ' listTotal: ' + listTotal + ' rowCountPerPage: ' + rowCountPerPage, 'reminingLinesToFill', reminingLinesToFill, 'maxRowsPerPage', maxRowsPerPage, 'pageNumber',pageNumber )
        return (
            listTotal !== 0 && rowCountPerPage % maxRowsPerPage === 0 && rowCountPerPage < listTotal ? 
            (
                <React.Fragment key={rowKey + '_' + rowCountPerPage +  '_Fragment'}> 
                    <tbody className='printpage_data' key={rowKey + '_' + rowCountPerPage + '_pageBreak'}>
                        <tr >               
                            <td>{item['ORDERQTY']}</td>                                                              
                            <td style={{textAlign:'center'}}>{item['SHIPPEDQTY']}</td>
                            <td>{item['UNIT']}</td>
                            <td>{item['INVOICEPARTNO']}</td>
                            <td>{item['INVOICEDESC']}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>                        
                        </tr>                                                                     
                    </tbody>  
                    {FooterTable(invno, false)}
                    {PageBreak(invno, index, '_PageBreakMaxedRow')}
                    
                    {HeaderTable(invno,invnoData)}

                </React.Fragment>
                
            ) : 
            (
                <tbody className='printpage_data' key={rowKey + '_' + rowCountPerPage}>
                    <tr >                                                                             
                        <td>{item['ORDERQTY']}</td>                                                              
                        <td style={{textAlign:'center'}}> {item['SHIPPEDQTY']}</td>
                        <td>{item['UNIT']}</td>
                        <td>{item['INVOICEPARTNO']}</td>
                        <td>{item['INVOICEDESC']}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>   
                    </tr> 
                </tbody>
            )
        )
    })


    let fillTable = (key, reminingLinesToFill) => [...Array(reminingLinesToFill)].map((x, i) =>{
        rowCountPerPage += 1
        reminingLinesToFill = (rowCountPerPage % maxRowsPerPage === 0) ? 0 : maxRowsPerPage - (rowCountPerPage % maxRowsPerPage);
        // console.log('InvoicesPrintPage fillTable key: ' + key + ' reminingLinesToFill: ' + reminingLinesToFill + ' rowCountPerPage: ' + rowCountPerPage + ' pageNumber: ' + pageNumber)
        return (            
            <tbody className='printpage_data' key={key + '_' + rowCountPerPage + '_fillTable'}>                
                <tr >   
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>            
            </tbody> 
            
        ) 
    })

    let coreTable = (invno, invnoData) => {
        // console.log('InvoicesPrintPage coreTable invno: ' + invno)

        var invnoHeadingInfo = invnoData[0]
        var rowKey = invno + '_' + invnoHeadingInfo['CUSTNO'];
        return (  
           
            <div key={rowKey} className='coreTableDivCN'>
                <table >
                    <thead>
                        <tr>
                            <td className={'logo'}>
                                <img src={fmplogo} alt='FMP Logo' width={142}/>                                        
                                <br/>
                                <span className={'fmpCorpAddress'}>                                        
                                    2782 EAGANDALE BOULEVARD<br/>
                                    EAGAN, MN 55121-1202<br/>
                                    Phone: 651-405-3610 --- Questions/Concerns: 920-224-2445 
                                </span>
                            </td>                            
                            <th colSpan={2}>Customer Core Pickup</th>
                        </tr>
                    </thead>
                    <tbody >                
                        <tr>
                            <td colSpan={2}>
                                <table>
                                    <thead>                                        
                                    </thead>                    
                                    <tbody className='customerCoreHeading'>                
                                        <tr>   
                                            <td >Customer#:</td>
                                            <td>{invnoHeadingInfo['CUSTNO']}</td>
                                        </tr>
                                        <tr>   
                                            <td>Custname:</td>
                                            <td>{invnoHeadingInfo['SHIP_TO_NAME']}</td>
                                        </tr>           
                                        <tr>   
                                            <td>Address:</td>
                                            <td>
                                                {invnoHeadingInfo['SHIP_TO_ADDR1']}<br/>
                                                {invnoHeadingInfo['SHIP_TO_ADDR2']} {invnoHeadingInfo['SHIP_TO_ADDR2'] !== '' ? <br/> : ''}
                                                {invnoHeadingInfo['SHIP_TO_ADDR3']} {invnoHeadingInfo['SHIP_TO_ADDR3'] !== '' ? <br/> : ''}
                                                {invnoHeadingInfo['SHIP_TO_CITY']}, {invnoHeadingInfo['SHIP_TO_STATE']} {invnoHeadingInfo['SHIP_TO_ZIP']}<br/>
                                                <br/>                    
                                                {invnoHeadingInfo['SHIP_TO_CUST_PHONE']}<br/>                        
                                            </td>
                                        </tr>
                                    </tbody> 
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {invnoHeadingInfo['WARRANTY_EXCLUSIONS'] === false ? 
                    <div>
                        <hr/>
                        Qty of Batteries Returned for Warranty Request __________________
                        <br/>
                        (DO NOT include warranty batteries in count below) 
                        <br/>
                        Customer must include battery warranty form for warranty credit requests. Part numbers, other info, and date codes required
                        <hr/>
                    </div>
                : ''
                }
                <div style={{paddingTop:'10px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                    Battery Cores Collected
                </div> 

                <div style={{padding:'2px'}}>
                    Customer PO/Comments __________________________________________
                </div>  

                <table>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Pickup Qty</th>
                        </tr>
                    </thead>
                    <tbody>                
                        <tr>   
                            <td>BCRSM-CORE (U1's, Small SLA's, Power Sport)</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>BCRMD-CORE (Auto/Marine not group 31)</td>
                            <td>_______________</td>
                        </tr>           
                        <tr>   
                            <td>BCRLG-CORE (4D, 8D & All group 31)</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>BCRCOREGOLF-EA (Golf)</td>
                            <td>_______________</td>
                        </tr>                                                                                                       
                    </tbody> 
                </table>  

                <table className='signatureTblCN'>
                    <thead></thead>
                    <tbody>
                        <tr>                                
                            <td className='footerSignatureBoxColCN'    style={{paddingLeft:'3px'}}>
                                <table>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table>
                                                    <thead></thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Customer's Signature</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Print Name</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Date</td>
                                                            <td>_____________________________</td>
                                                        </tr>    
                                                    </tbody>                                            
                                                </table>
                                            </td>
                                            <td>
                                                <table>
                                                    <thead></thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Driver's Signature</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Print Name</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Date</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                    </tbody>                                         
                                                </table>
                                            </td>                                
                                        </tr> 
                                    </tbody>
                                                
                                </table>
                            </td>
                        </tr>
                    </tbody>

                </table>    

                <div style={{paddingTop:'8px'}}>
                    <hr/>
                    ----- Internal Use Only -----
                </div>

                <div style={{paddingTop:'5px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                     Rotate Request
                </div> 
                <table>
                    <thead>
                        <tr>
                            <th>Partno (i.e. FVPP65)</th>
                            <th>Voltage</th>
                            <th>Date Code</th>
                        </tr>
                    </thead>
                    <tbody>                
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>                                                                                                                                                   
                    </tbody>
                </table> 

                <div>
                    <div style={{paddingTop:'5px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                        New Battery Return
                    </div> 
                    <table>
                        <thead>
                            <tr>
                                <th>Partno (i.e. FVPP48)</th>
                                <th>Qty</th>
                                <th>Partno (i.e. FVPP48)</th>
                                <th>Qty</th>                                
                            </tr>
                        </thead>
                        <tbody>                
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>       
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>                        
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>                                                                                                                                                                             
                        </tbody>
                    </table>
                </div> 
  

            </div>
       
     

            
        ) 
    }

    

    // console.log('InvoicesPrintPage maxRowsPerPage: ', maxRowsPerPage, ' listTotal: ', listTotal, ' calcPageTotal: ', (Math.floor(listTotal/maxRowsPerPage)))

    let combinePrintComponents = () => {
       return( 
        Object.keys(invoicesPrintState).map((key, index) => (
             
            <div key={key+'Fragment'}>
                <table ref={ref} className='printpage' key={key+'table'}>
                    {/* {console.log('InvoicesPrintPage rotate request:', invoicesPrintState[key][0]['ROTATE_REQUEST'] )}                     */}
                    {/* {console.log('InvoicesPrintPage invnoData:' + JSON.stringify(invoicesPrintState[key] ))} */}
                    {/* {console.log('InvoicesPrintPage invnoData length:', Object.values(invoicesPrintState[key]).length)} */}

                    {HeaderTable(key, invoicesPrintState[key])}
                    {itemList(key, invoicesPrintState[key]) }
        
                    {/* {console.log('InvoicesPrintPage printpage key: ' + key + ' reminingLinesToFill: ' + reminingLinesToFill + ' rowCountPerPage: ' + rowCountPerPage + ' maxRowsPerPage: ' + JSON.stringify(maxRowsPerPage) + ' calc: ' + (maxRowsPerPage % rowCountPerPage) + " itemList: " + itemList.length, 'pageNumber', pageNumber)} */}
        
                    {fillTable(key, reminingLinesToFill)}  

                    {FooterTable(key, true)}
    
                    {/* To page break for cores */}
                    {invoicesPrintState[key][0]['ROTATE_REQUEST'] !== -1 ? PageBreak(key,index,'_PageBreakForCores') : ''}

                </table>

               
                {invoicesPrintState[key][0]['ROTATE_REQUEST'] !== -1 ? coreTable(key, invoicesPrintState[key]) : ''}

                {/* To only page break if there are more invoices */}
                {Object.keys(invoicesPrintState).length !== index+1 && Object.keys(invoicesPrintState).length > index+1 ? (
                    <table key={key+'_TblPageBreakEndOfInvoice'}>
                        <thead></thead>
                        {PageBreak(key, index,'_PageBreakEndOfInvoice')}
                    </table>                        
                    ): ''
                }



            </div>
        ))   
       )     
    }

    return (
        <div className='page'>

        {console.log('InvoicesPrintPage Object.keys(invoicesPrintState).length: ',  Object.keys(invoicesPrintState).length )}
        {console.log('InvoicesPrintPage invoicesPrintState: ',  invoicesPrintState )}


        
        { invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['ROTATE_REQUEST'] === -1 ? 
            <>    
                {/* -- For Rotate Results Only -- */}
                <SopRotatesPrintPage/> 

                <table key={'sopRotates_TblPageBreak'}>
                    <thead></thead>
                    {PageBreak('EndOfComponent', 'EndOfComponent','sopRotates_PageBreakEndOfComponent')}
                </table>              
            </>                    
        : '' }

        {combinePrintComponents()}

        {/* Requested for duplicate copy of invoice printout */}
        <table key={'_TblPageBreakEndOfComponent'}>
            <thead></thead>
            {PageBreak('EndOfComponent', 'EndOfComponent','_PageBreakEndOfComponent')}
        </table>  

        {combinePrintComponents()}

        { invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['ROTATE_REQUEST'] === -1 ? 
            <>
                {/* -- For Rotate Results Only -- 
                PURPOSE: So they can print and take to warehouse 
                and record voltage and date codes to come back 
                and easily enter into webpage when confirming */}
                {/* <InvoicesRotatesTablePrintPage/>              */}

                <table key={'_TblPageBreakEndOfComponent'}>
                    <thead></thead>
                    {PageBreak('EndOfComponent', 'EndOfComponent','_PageBreakEndOfComponent')}
                </table>  

                <table key={'rotatesTablePrintPage'} style={{width:'100%', padding: '40px'}}>
                    <thead>
                        <tr>
                            <th>Rotates Results to be entered on website when confirming delivery</th>
                        </tr>
                        <tr>
                            <td>
                                Custno: {invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['CUSTNO']}
                            </td>
                        </tr>
                        <tr>
                            <td style={{paddingBottom:'20px'}}>
                                Invno: {invoicesPrintState[Object.keys(invoicesPrintState)[0]][0]['INVNO']}
                            </td>
                        </tr> 
                        <tr>
                            <td style={{paddingBottom:'20px'}}>
                                'Rotate Result' options: Completed, Cancelled
                            </td>
                        </tr>                                                 
                    </thead>
                    <tbody>
                        
                        <tr>
                            <td>
                                <RotatesTable print={true} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </>                    
        : '' }

        </div>
    );
})


const mapStateToProps = (state) => {
   return {
    invoicesState: state.invoicesReducer['items_fetchInvoices'],
    invoicesPrintState: state.invoicesReducer['items_fetchInvoicesPrint'],
    //  authreducerState: state.authreducer
   }
  
};
  
const mapDispatchToProps = (dispatch) => {
    return {   

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesPrintPage);